import { render } from "./CarrierTable.vue?vue&type=template&id=31b9a4f0&scoped=true"
import script from "./CarrierTable.vue?vue&type=script&lang=js"
export * from "./CarrierTable.vue?vue&type=script&lang=js"

import "./CarrierTable.vue?vue&type=style&index=0&id=31b9a4f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31b9a4f0"

export default script